<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="invoice-page">
    <div class="A4">
      <h4 class="text-center mb-5 mt-5 non-printer">Versão Impressão</h4>
      <div
        v-if="dadosRateio.length == 0"
        class="alert alert-danger text-center"
      >
        Nenhum boleto disponivel para impressão neste Rateio
      </div>
      <div v-else v-for="(item, index) in dadosRateio" :key="item.id_boleto">
        <div class="sheet">
          <div class="div1">
            <img :src="item.dadosEmpresa.capaBoleto" width="100%" />
          </div>
          <div class="div2">
            <div class="wrapper">
              <h3>Vencimento Boleto {{ item.vencimento }}</h3>
              <div class="content invertida">
                <img :src="item.dadosEmpresa.Logo" width="300" />
                <div class="box">
                  DESTINATARIO:<br />
                  <p>{{ item.dadosAssociado.nome }}</p>
                  <p>
                    Rua: {{ item.dadosAssociado.endereco }},
                    {{ item.dadosAssociado.numero }}
                    {{ item.dadosAssociado.complemento }}<br />
                    {{ item.dadosAssociado.bairro }} -
                    {{ item.dadosAssociado.cidade }}-
                    {{ item.dadosAssociado.estado }} - cep:
                    {{ item.dadosAssociado.cep }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="div3">
            <div class="wrapper2">
              <h3>
                Vencimento Boleto {{ item.vencimento
                }}<span>{{ index + 1 }}</span>
              </h3>

              <div
                class="content"
                :style="retornaStyle(item.dadosEmpresa.razaoSocial)"
              >
                <div class="box">
                  <p>REMETENTE:<br /></p>

                  <p>{{ item.dadosEmpresa.razaoSocial }}</p>
                  <p>
                    Rua: {{ item.dadosEmpresa.endereco }},
                    {{ item.dadosEmpresa.numero }}
                    {{ item.dadosEmpresa.complemento }}<br />
                    {{ item.dadosEmpresa.bairro }} -
                    {{ item.dadosEmpresa.cidade }}-
                    {{ item.dadosEmpresa.estado }} - cep:
                    {{ item.dadosEmpresa.cep }}
                  </p>
                </div>
              </div>
              <div class="box2">
                <table width="100%" cellspacing="0px" cellpadding="0">
                  <tr>
                    <td width="50%" style="border-right: 1px solid black">
                      <div style="padding: 2px 5px">Uso dos Correios</div>
                      <table
                        style="font-size: 10px; padding-left: 5px"
                        width="100%"
                        cellspacing="0px"
                        cellpadding="0"
                      >
                        <tr>
                          <td>
                            [&nbsp;&nbsp;] Mudou-se <br />
                            [&nbsp;&nbsp;] Endereço insulficiente <br />
                            [&nbsp;&nbsp;] Número Inexistente <br />
                            [&nbsp;&nbsp;] Desconhecido
                          </td>
                          <td width="60%">
                            [&nbsp;&nbsp;] Recusado <br />
                            [&nbsp;&nbsp;] Ausente <br />
                            [&nbsp;&nbsp;] Falecido <br />
                            [&nbsp;&nbsp;] Instr. escrita para
                            porteiro/zelador<br />
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td width="50%">
                      <table width="100%" cellspacing="0px" cellpadding="0">
                        <tr>
                          <td width="30%" style="border-right: 1px solid black">
                            <div style="padding: 2px 5px; height: 40px">
                              Data
                            </div>
                          </td>
                          <td width="70%">
                            <div style="padding: 2px 5px">
                              Reintegrado ao serviço postal em
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="2" style="border-top: 1px solid black">
                            <div style="padding: 2px 5px">
                              Assinatura do entregador
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="div4">
            <img :src="item.dadosEmpresa.contraCapaBoleto" width="100%" />
          </div>
        </div>
        <div class="quebraPagina">
          <boleto :dados="item.dadosToBoleto"></boleto>
          <!--pdf
            v-if="!item.urlImagemBoleto"
            class="pdf"
            :src="item.link_boleto"
          ></pdf>
          <img
            v-else
            class="imgBoleto"
            :src="item.urlImagemBoleto"
            @load="onImgLoad"
          /-->
        </div>
      </div>
    </div>
    <div>
      <vs-popup
        fullscreen
        class="holamundo"
        :title="'Atenção existe boletos com erros'"
        :active.sync="modalInfoBoletoErros"
        @close="modalInfoBoletoErros = false"
      >
        <!-- 
        id_associado
        nome
        mensagem
        detalhes
       -->
        <vs-alert
          v-if="this.boletosComErros.length"
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
        >
          <ul>
            <li class="mb-2">
              Após a correção dos erros os boletos devem ser reprocessados.
            </li>
          </ul>
        </vs-alert>

        <table class="table-bordered mt-3">
          <tr>
            <th>Beneficiário</th>
            <th>Erro</th>
            <th>Detalhes</th>
          </tr>
          <tr v-for="item in boletosComErros" :key="item.id_associado">
            <td>
              {{ item.nome }}
              <router-link
                target="_blank"
                :to="`/DetalheAssociado/${item.id_associado}`"
              >
                <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
              </router-link>
            </td>
            <td>
              {{ item.mensagem }}
            </td>
            <td>
              {{ item.detalhes }}
            </td>
          </tr>
        </table>
      </vs-popup>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import service from './../../services';
import moment from 'moment';
import vSelect from 'vue-select';
import locale from './../../locale';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

import boleto from './../Includes/boleto.vue';
export default {
  data() {
    return {
      carregando: true,
      dadosRateio: [],
      logo: 'https://bboneapp.s3.amazonaws.com/evo-gerencial-color.png',
      totalImagensCarregadas: 0,
      boletosComErros: [],
      modalInfoBoletoErros: false,
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    retornaStyle(nomeEmpresa) {
      //return "background-color:red";
      return `background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='20px' width='120px'><text x='0' y='15' fill='black' font-size='12'>${nomeEmpresa}</text></svg>");`;
    },
    buscaDadosToImpressao() {
      var objSend = {};
      objSend.idRateio = this.$route.params.idRateio;
      this.$vs.loading();
      service
        .post('Rateios', 'buscarDadoToImpressao', objSend)
        .then((res) => {
          this.carregando = false;
          this.$vs.loading.close();
          res.data.forEach((element) => {
            element.dadosAssociado = JSON.parse(element.dadosAssociado);
            element.dadosAssociado = element.dadosAssociado[0];

            element.dadosEmpresa = JSON.parse(element.dadosEmpresa);
            element.dadosEmpresa = element.dadosEmpresa[0];

            var dadosGalax = JSON.parse(element.retornoApi);

            const temPropChargeEmDadosGalax =
              dadosGalax.hasOwnProperty('Charge');
            dadosGalax = temPropChargeEmDadosGalax
              ? dadosGalax.Charge
              : dadosGalax;

            if (dadosGalax.hasOwnProperty('error')) {
              const id_associado = dadosGalax.objSend.Customer.myId;
              const nome = dadosGalax.objSend.Customer.name;
              const mensagem = dadosGalax.error.message;

              const detalhes = Object.values(dadosGalax.error.details).reduce(
                (acc, item) => (acc += '- ' + item + '\n'),
                '',
              );

              this.boletosComErros.push({
                id_associado,
                nome,
                mensagem,
                detalhes,
              });

              return;
            }

            var dadosToBoleto = {
              dadosEmpresa: {
                nome: element.dadosEmpresa.razaoSocial,
                cpfcnpj: element.dadosEmpresa.cnpj,
                endereco: element.dadosEmpresa.endereco,
                numero: element.dadosEmpresa.numero,
                complemento: element.dadosEmpresa.complemento,
                bairro: element.dadosEmpresa.bairro,
                cidade: element.dadosEmpresa.cidade,
                estado: element.dadosEmpresa.estado,
                cep: element.dadosEmpresa.cep,
                logo: element.dadosEmpresa.Logo,
              },
              dadosPagador: {
                nome: element.dadosAssociado.nome,
                cpfcnpj: element.dadosAssociado.cpfcnpj,
                endereco: element.dadosAssociado.endereco,
                numero: element.dadosAssociado.numero,
                complemento: element.dadosAssociado.complemento,
                bairro: element.dadosAssociado.bairro,
                cidade: element.dadosAssociado.cidade,
                estado: element.dadosAssociado.estado,
                cep: element.dadosAssociado.cep,
              },
              dadosCobranca: {
                id: element.id_boleto,
                descricao: dadosGalax.PaymentMethodBoleto.instructions,
                dataVencimento: dadosGalax.Transactions[0].payday,
                dataEmissao: dadosGalax.Transactions[0].createdAt,
                valor: parseInt(dadosGalax.Transactions[0].value) / 100,
                nossoNumero: dadosGalax.Transactions[0].Boleto.bankNumber,
                instrucao: `Este boleto pode ser pago em qualquer banco, mesmo que vencido, desde que não ultrapasse ${dadosGalax.PaymentMethodBoleto.deadlineDays} dia(s) da data do vencimento
(sujeito a multa e juros)`,
                linhaDigitavel: dadosGalax.Transactions[0].Boleto.bankLine,
                barCode: dadosGalax.Transactions[0].Boleto.barCode,
                banco: dadosGalax.Transactions[0].Boleto.bankEmissor,
                veiculos: JSON.parse(element.veiculos),
                pix: dadosGalax.Transactions[0].Pix
                  ? dadosGalax.Transactions[0].Pix.qrCode
                  : null,
              },
            };

            element.dadosToBoleto = dadosToBoleto;
            this.dadosRateio.push(element);
          });

          const temBoletosComErro = this.boletosComErros.length > 0; //&& index >= array.length - 1;

          if (temBoletosComErro) {
            this.modalInfoBoletoErros = true;

            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Ocorreu erros no momento de geração dos boletos',
              color: 'danger',
            });

            this.dadosRateio = [];
          }
        })
        .catch((e) => {
          console.log(e);
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao Buscar Rateio',
            color: 'danger',
          });
        });
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.buscaDadosToImpressao();
  },
  components: {
    'v-select': vSelect,
    VueJsonPretty,

    boleto,
  },
};
</script>
<style>
.div1,
.div2,
.div3,
.div4 {
  height: calc(290mm / 3);
  margin: 5px;
}
table td,
table td * {
  vertical-align: top;
}
@page {
  margin: 0;
}
body {
  margin: 0;
  color: #000000 !important;
  font-weight: 700;
}
.sheet {
  margin: 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  page-break-after: always;
}
.quebraPagina {
  page-break-after: always;
  width: 210mm;
  padding: 5px 10px 5px 15px;
}

/** Paper sizes **/
.A3 .sheet {
  width: 297mm;
  height: 419mm;
}
.A3.landscape .sheet {
  width: 420mm;
  height: 296mm;
}
.A4 .sheet {
  width: 210mm;
  height: 296mm;
}
.A4.landscape .sheet {
  width: 297mm;
  height: 209mm;
}
.A5 .sheet {
  width: 148mm;
  height: 209mm;
}
.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm;
}
.sheet.padding-15mm {
  padding: 15mm;
}
.sheet.padding-20mm {
  padding: 20mm;
}
.sheet.padding-25mm {
  padding: 25mm;
}

/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0;
  }
  .sheet,
  .quebraPagina {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin: 5mm;
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}
</style>
<style lang="scss">
.wrapper {
  width: 100%;
  min-height: 250px;
  position: relative;
  padding: 15px;
  color: rgba(black, 0.5);
  font-size: small;
  display: inline-block;
  height: calc(290mm / 3);
  .invertida {
    transform: rotate(-180deg);
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    -o-transform: rotate(-180deg);
  }
  .content {
    //margin-top: 60px;
    margin-right: 100px;
    .box {
      padding: 20px;
      border: 1px solid black;
      width: 80%;
      color: black;
    }
  }
  h3 {
    font-size: 1rem;
    text-transform: uppercase;
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: -100px;
    margin-bottom: 160px;
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
  }
}

.wrapper2 {
  width: 100%;
  min-height: 250px;
  position: relative;
  border-left: 40px solid transparent;
  padding: 15px;
  color: rgba(black, 0.5);
  font-size: small;
  display: inline-block;
  height: calc(290mm / 3);
  .content {
    background-color: #ccc;
    height: 258px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .box {
      width: 500px;
      height: 150px;
      background: #fff;
      border: 1px solid black;
      border-radius: 30px;
      padding: 20px;
      color: black;
    }
  }
  .box2 {
    width: 100%;
    background: #fff;
    border: 1px solid black;
    color: black;
  }
  h3 {
    font-size: 1rem;
    text-transform: uppercase;
    position: absolute;
    top: 0;
    left: 0;
    margin-left: -160px;
    margin-top: 160px;
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    span {
      font-size: 9px;
      margin-left: 45px;
    }
  }
}
</style>

<style lang="scss">
@media screen {
  .printer {
    display: none;
  }
}
@media print {
  .table-bordered {
    tr:nth-child(2n) {
      background-color: #ffffff !important;
    }
  }
  .non-printer {
    display: none;
  }
  .vue-back-to-top {
    display: none !important;
  }
  .pdf {
    width: auto;
    height: 200mm;
  }
  .folha {
    height: 297mm;
    padding: 0 0 0 0;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }

  .detalheProposta {
    .vs-col {
      width: 100% !important;
    }

    .filtroFotos {
      display: none !important;
    }

    .cardFotos {
      width: 60% !important;
      img {
        height: 100%;
      }
      footer {
        display: none !important;
      }
    }

    h3 {
      button {
        display: none !important;
      }
    }
  }
}
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  border: 1px solid gray;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
